import styled from "styled-components";

export const Layout = styled.div<{ background?: string; listMode?: boolean }>`
  display: block;
  width: 100%;
  min-width: 200px;
  background: ${props => props.background || "inherit"};
  scrollbar-width: thin;
  overflow: visible;
  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: var(--section-granite-background-color, var(--granite));
    height: 4px;
  }

  ${props =>
    !props.listMode &&
    `
      background: transparent;
      border-radius: 4px;
      overflow: hidden;
    `};
`;
